import { localStorageSingleton } from '@zcode/nr-utils'
import { toCamelCase } from '@zcode/utils'
import { logger } from '../logger'
import { formatParamsForRecEngine } from '../module/helpers/formatParamsForRecEngine'
import type { ParamsType } from '../types'

const FOR_YOU_PREFIX = 'blueshiftForYou'

export const composeBlueshiftEvent = () => {
  try {
    const url = new URLSearchParams(window.location.search)
    const location: string | null = url.get('location')

    const forYouState = localStorageSingleton.get('for-you') ?? {}

    const { limit, ...recEnginePayload } = formatParamsForRecEngine(forYouState)

    const payload: ParamsType = {
      cityState: location,
      ...recEnginePayload,
    }

    return Object.keys(payload).reduce(
      (prev, value) => ({
        ...prev,
        [toCamelCase(`${FOR_YOU_PREFIX}_${value}`)]: payload[value],
      }),
      {}
    )
  } catch (e) {
    logger.error(`Failed to compose blueshift event for For You`, e)

    return {}
  }
}
